module.exports = __webpack_public_path__ + "static/media/yushanadj.1d85d61d.webp";